import axios from '.';

export default {
  changeVisibilityForVideoStore,
};

async function changeVisibilityForVideoStore(postId, data) {
  const response = await axios.put(`/api/posts/${postId}/change_visibility_for_video_store`, data);
  return response.data;
}

